export default __webpack_public_path__ + "static/media/arrow-white.99ef6fee.svg";